export default [
  {id: 'basic', name: 'BUTACA', value: 0},
  {id: 'bunk', name: 'LITERA', value: 1},
  {id: 'cabin2i', name: 'CAMAROTE INTERIOR 2 CAMAS ', value: 2},
  {id: 'cabin2e', name: 'CAMAROTE EXTERIOR 2 CAMAS ', value: 3},
  {id: 'cabin4i', name: 'CAMAROTE INTERIOR 4 CAMAS ', value: 4},
  {id: 'cabin4e', name: 'CAMAROTE EXTERIOR 4 CAMAS ', value: 5}
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/locations.js